export const REJECTED_STATUS_ID = 0;
export const SUBMITTAL_STATUS_ID = 30;
